import { Amplify } from 'aws-amplify';

export function configureCognito(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
      },
    },
  });
}
